import { sql } from "drizzle-orm";
import { text } from "drizzle-orm/sqlite-core";
import { ulid } from "ulidx";

/**
 * Prefixed string primary key — recursive-mls convention (`<entity>_key` column,
 * value `<prefix>_<rand>`, generated app-side, never autoincrement). The TS
 * property is conventionally named `id`; only the DB column carries the
 * `<entity>_key` name.
 */
export const key = (column: string, prefix: string) =>
  text(column)
    .primaryKey()
    .$defaultFn(() => `${prefix}_${ulid().toLowerCase()}`);

/**
 * TEXT ISO-8601 timestamps with the exact `strftime` default recursive-mls uses,
 * so DB-generated defaults match app-side `new Date().toISOString()` writes
 * (millisecond precision, trailing Z) and sort consistently.
 */
const nowIso = sql`(strftime('%Y-%m-%dT%H:%M:%fZ', 'now'))`;

export const timestamps = {
  createdAt: text("created_at").notNull().default(nowIso),
  updatedAt: text("updated_at")
    .notNull()
    .default(nowIso)
    .$onUpdateFn(() => new Date().toISOString()),
};
